import type { FC } from "react";

interface CustomLegendProps {
  readonly payload?: Array<{
    color: string;
    value: string;
  }>;
}

export const CustomLegend: FC<CustomLegendProps> = ({ payload }) => {
  if (!payload) return null;

  return (
    <div className="bg-card border-border flex flex-wrap gap-2 rounded-lg border p-2 shadow-lg dark:bg-gray-800">
      {payload.map((entry, index) => (
        <span
          key={`legend-${index}`}
          className="flex items-center gap-1 text-xs"
        >
          <span
            className="inline-block h-2 w-2"
            style={{ backgroundColor: entry.color }}
          />
          {entry.value}
        </span>
      ))}
    </div>
  );
};
